import {isFunction, isEmpty} from 'lodash';
import AblyService from './ably';
import {CHAT_EVENT} from '../configs/constants';

export default class ChatService {
  constructor(channelId) {
    this.channel = AblyService.realtime.channels.get(channelId);
  }
  init({onHistory, onMessage = () => {}}) {
    if (isFunction(onHistory)) {
      // ably v2: channel.history() returns a Promise resolving to a
      // PaginatedResult (with `items`) instead of taking an (err, page) callback.
      this.channel.history()
        .then((page) => {
          if (!page) {
            return onHistory([]);
          }
          const {items} = page;
          if (isEmpty(items)) {
            return onHistory([]);
          }
          const messages = items.map(i => i.data);
          return onHistory(messages);
        })
        .catch((err) => {
          console.error('Failed to fetch chat history:', err);
          onHistory([]);
        });
    }
    this.channel.subscribe((message) => {
      const {data, name} = message;
      if (name !== CHAT_EVENT) {
        return false;
      }
      return onMessage(data);
    });
  }
  sendMessage(message) {
    this.channel.publish(CHAT_EVENT, message);
  }
  unSubscribe() {
    this.channel.unsubscribe();
  }
}
